import { render, staticRenderFns } from "./LoanCollateralAssetImmovableFieldsEdit.vue?vue&type=template&id=040d2120&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetImmovableFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetImmovableFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetImmovableFieldsEdit.vue?vue&type=style&index=0&id=040d2120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d2120",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetImmovableFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports